import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { formatMinutes } from '../../utils/effortParser';
import { DAILY_WARNING_MINUTES } from '../../utils/worklogRules';
import { cardSx, cardTitleSx, GREEN, INK, MUTED, SERIES } from '../home/homeTheme';

/** Ore del giorno per progetto, con il totale rispetto alle 8 ore. */
export default function DayProjectsCard({ worklogs }) {
  const byProject = {};
  worklogs.forEach((w) => {
    const name = w.project_name || 'N/A';
    byProject[name] = (byProject[name] || 0) + (Number(w.effort) || 0);
  });
  const items = Object.entries(byProject).sort((a, b) => b[1] - a[1]);
  const total = items.reduce((sum, [, m]) => sum + m, 0);
  const over = total > DAILY_WARNING_MINUTES;

  return (
    <Box sx={{ ...cardSx, height: 'auto' }}>
      <Typography sx={{ ...cardTitleSx, mb: 1.5 }}>Hours by project</Typography>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
        <Typography sx={{ fontSize: 30, fontWeight: 800, color: over ? 'var(--rt-warn)' : INK, lineHeight: 1.1 }}>{formatMinutes(total)}</Typography>
        <Typography sx={{ fontSize: 14, color: MUTED }}>of 8h</Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={Math.min(100, (total / DAILY_WARNING_MINUTES) * 100)}
        sx={{ height: 8, borderRadius: 4, my: 1.25, bgcolor: 'var(--rt-track)', '& .MuiLinearProgress-bar': { bgcolor: over ? '#EF7A1A' : GREEN, borderRadius: 4 } }}
      />
      {over && <Typography sx={{ fontSize: 12.5, color: 'var(--rt-warn)', mb: 1 }}>{formatMinutes(total - DAILY_WARNING_MINUTES)} over 8h</Typography>}
      {items.length === 0 ? (
        <Typography sx={{ fontSize: 13, color: MUTED }}>No hours on this day yet.</Typography>
      ) : (
        items.map(([name, minutes], idx) => (
          <Box key={name} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.6 }}>
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: SERIES[idx % SERIES.length], flexShrink: 0 }} />
            <Typography noWrap sx={{ fontSize: 13, color: INK, flex: 1, minWidth: 0 }} title={name}>
              {name}
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: INK }}>{formatMinutes(minutes)}</Typography>
          </Box>
        ))
      )}
    </Box>
  );
}
